import Button from "@material-ui/core/Button";
import React, { Fragment, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import HTTPClient from "../../HTTPClient";
import Loading from "../Loading";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import {getMessage} from "../../util";

const useStyles = makeStyles(theme => ({
        paper: {
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(2),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'left',
        },
        voted: {
            marginTop: theme.spacing(4),
        },
        paragraph: {
            margin: theme.spacing(2)
        },
        cardGrid: {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8),
        },
        card: {
            marginTop: theme.spacing(4),
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
        },
        cardActions: {
            justifyContent: 'center',
        },
        cardContent: {
            flexGrow: 1,
        },
        option: {
            margin: theme.spacing(3),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        option_label: {
            color: 'black'
        },
        center: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        label: {
            alignItems: 'left',
        },
        textField: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            width: '25ch',
        },

    }
));

const Resume = (props) => {
    const classes = useStyles();
    const [loading, setLoading] = useState(false);

    const vote = () => {

        const data = props.answers.map(a => {
            return ({option_id: a._id, votes: a.votes})
        });
        setLoading(true);
        HTTPClient({
            method: "post",
            data: {answers: data},
            url:
                process.env.REACT_APP_API_URL +
                "/meetings/" + props.meeting.slug + "/questions/" + props.question.slug + "/vote"
        })
            .then(response => {

                setLoading(false);

                if (response.data) {
                    props.vote();
                } else {
                    window.alert(getMessage(props.meeting.meeting_type, 'answer_cannot_sent', props.messages));

                }

            }).catch((error) => {
            console.log(error);
            window.alert(getMessage(props.meeting.meeting_type, 'answer_cannot_sent', props.messages));
            setLoading(false);

        });


    }


    const option = props.answers.reduce((acc, o) => {
        Object.keys(o.votes).forEach(k => {
            if (o.votes[k].shares > 0) {
                acc[k] = o.name;
            }
        });
        return (acc);

    }, {});

    const question_shares =  Object.keys(props.question.blanks)
    const representative_question =  Object.keys(props.user.shares).filter((x) => {
        if(question_shares.indexOf(x) === -1)
            return false;
        else
            return true;
    });

    return (<Dialog
        open={true}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle id="alert-dialog-title">
            {getMessage(props.meeting.meeting_type, 'answer_confirm_title', props.messages)}
        </DialogTitle>

            <DialogContent>

                <div className={classes.paragraph}>
                    {option && representative_question.map(k => (
                        <Typography key={k} variant={"h6"}>
                            {props.user.shares[k].name}: {option[k] ? option[k] : getMessage(props.meeting.meeting_type, 'blank', props.messages)}
                            <br/>
                        </Typography>
                    ))}
                </div>


            </DialogContent>

        {loading ? (
            <Loading/>

        ) : (
            <DialogActions>
                <Button onClick={props.handleClose} autoFocus>
                    {getMessage(props.meeting.meeting_type, 'back', props.messages)}
                </Button>
                <Button variant="contained" color={"primary"} onClick={vote}>
                    {getMessage(props.meeting.meeting_type, 'answer_confirm_button', props.messages)}
                </Button>
            </DialogActions>

        )}


    </Dialog>);
}

const OptionsSingle = (props) => {

    const classes = useStyles();
    const [resume, setResume] = useState(false);

    const question_shares =  Object.keys(props.question.blanks)
    const representative_question =  Object.keys(props.user.shares).filter((x) => {
        if(question_shares.indexOf(x) === -1)
            return false;
        else
            return true;
    });

    const [answers, setAnswers] = useState(props.question.options.map(o => {
        o.votes = representative_question.reduce((acc, k) => {
            acc[k] = {
                name: props.user.shares[k].name,
                shares: 0
            };
            return (acc);
        }, {});
        return (o)
    }));


    const [value, setValue] = React.useState(representative_question.reduce((acc, k) => {
        acc[k] = "";
        return (acc);
    }, {}));


    const handleClick = (event) => {

        const new_value = {};

        Object.keys(value).forEach(k => {
            new_value[k] = value[k];
        }, {});

        if (event.target.value === value[event.target.name]) {
            new_value[event.target.name] = "";
            setValue(new_value);
        } else {
            new_value[event.target.name] = event.target.value;
            setValue(new_value);
        }

    }

    const votar = event => {

        /*
       {
           answers: [
           {
               option_id: String,
               votes: {
                   'A': {
                   name: String,
                   shares: Long
                   }
               }
           ]
       }
        */

        const votes = props.question.options.map(o => {
            const no = {};
            no._id = o._id;
            no.name = o.name;
            no.order = o.order;
            no.votes = representative_question.reduce((acc, k) => {
                acc[k] = {
                    name: props.user.shares[k].name,
                    shares: Number(o._id === value[k] ? 1 : 0)
                }
                return (acc);
            }, {})

            return (no)
        });

        setAnswers(votes);
        setResume(true);


    };


    const divide2 = representative_question.length>2?4:(12/representative_question.length);
    const divide1 = representative_question.length>1?6:12

    return (

        <Fragment>
            {resume && <Resume answers={answers} question={props.question} meeting={props.meeting} user={props.user}
                    handleClose={() => setResume(false)} vote={props.vote}/>}
            <Typography className={classes.paragraph} variant={"h6"}>
                {getMessage(props.meeting.meeting_type, 'vote_single_instruction', props.messages)}
            </Typography>

            <Container className={classes.option}>

                <form className={classes.form} noValidate>
                    <Grid container spacing={2} alignItems={"center"}>
                        {representative_question.map(k => (
                            <Grid key={k} item xs={12} sm={divide1} md={divide2}>
                             <Container>
                                 <Typography variant={"h6"}>
                                     {props.user.shares[k].name}
                                 </Typography>
                             </Container>
                                <RadioGroup aria-label="option" value={value[k]} name={k}>
                                    {props.question.options.sort((a, b) => {
                                        return (a.order - b.order);
                                    }).map(o => (
                                        <FormControlLabel key={o._id} value={o._id}
                                                          className={classes.option_label}
                                                          control={<Radio color="primary" onClick={handleClick}/>}
                                                          label={o.name}/>

                                    ))}
                                </RadioGroup>
                            </Grid>
                        ))}

                    </Grid>

                    <Container className={classes.option}>

                        <Button variant="contained" color={"primary"} onClick={votar}>
                            {getMessage(props.meeting.meeting_type, 'vote', props.messages)}
                        </Button>
                    </Container>


                </form>
            </Container>
        </Fragment>


    )
}

export default OptionsSingle;